import styled from "@emotion/styled"
import HeroSectionWrapper from "./HeroSectionWrapper"

const HeroScrollSectionWrapper = styled(HeroSectionWrapper)`
  margin-bottom: 40px;
  position: relative;
`

export default HeroScrollSectionWrapper
